<template>
    <div class="searchbar-wrapper d-flex align-items-center">
        <el-input v-model="query" clearable class="text-center mr-2" placeholder="Suchen ..." @input="queryChanged">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <i class="el-icon-s-operation" @click="toggleHeader"></i>
    </div>
</template>

<script>
export default {
    name: 'PDFSearchbar',
    props: {},
    data() {
        return {
            query: '',
        };
    },
    computed: {},
    methods: {
        queryChanged() {
            this.$emit('search', this.query);
        },
        toggleHeader() {
            this.$emit('toggleHeader');
        },
    },
};
</script>

<style scoped></style>
